import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {Customer, Reminder} from '~core/models';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {ReminderService} from '~core/services';
import {ReminderStatusTranslationsService, TooltipTranslationService} from '~shared/translations';

/**
 * Handles reminders
 */
@UntilDestroy()
@Component({
  selector: 'app-reminder-list',
  templateUrl: './reminder-list.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class ReminderListComponent implements OnInit, OnDestroy {
  public anim: any = '';
  public loading: boolean = true;
  public modalOpened: boolean = false;
  public currentReminders: Array<Reminder>;

  public columns: Array<string> = [];
  public keys: Array<Array<any>> = [];

  @Input() public customer: Customer;
  @Input() public isPanelOpened: boolean = true;
  @Output() public isPanelOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public customerOverviewService: CustomerOverViewService,
    public reminderService: ReminderService,
    public reminderStatusTranslations: ReminderStatusTranslationsService,
    public tablesTranslations: TablesTranslations,
    public tooltipTranslations: TooltipTranslationService,
  ) {
    this.reminderService.castReminderList.pipe(untilDestroyed(this))
      .subscribe(data => {
        if (data != null) {
          this.currentReminders = data;
        }
      });
    this.columns.push(this.tablesTranslations.i18nDeadline, this.tablesTranslations.i18nOwner,
      this.tablesTranslations.i18nComment, this.tablesTranslations.i18nStatus);
    this.keys.push(['deadline', 'owner.fullName', 'text', 'status']);
  }

  public ngOnInit(): void {
    this.getLatestReminders(this.customer.id);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Open the edit reminder modal and pass the address data to it.
   */
  public editReminder(reminder: Reminder): any {
    this.customerOverviewService.toggleAllModal(false);
    this.customerOverviewService.toggleEditReminderModal(true);
    this.reminderService.announceCurrentReminder(reminder);
  }

  /**
   * Open the edit reminder modal and pass the address data to it.
   */
  public createReminder(): any {
    this.customerOverviewService.toggleAllModal(false);
    this.customerOverviewService.toggleCreateReminderModal(true);
  }

  /**
   * Get the reminders for the current customer.
   */
  public getLatestReminders(id: number): any {
    this.reminderService.getAll(id, true).pipe(untilDestroyed(this))
      .subscribe((data: Array<Reminder>) => {
        this.reminderService.setReminderList(data);
      });
  }
}
